package team.platforma.materialextension.sample_screens

import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.itemsIndexed
import androidx.compose.foundation.lazy.rememberLazyListState
import androidx.compose.foundation.pager.rememberPagerState
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.Button
import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.compose.material3.Slider
import androidx.compose.material3.Text
import androidx.compose.material3.pulltorefresh.PullToRefreshBox
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateListOf
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.blur
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.unit.dp
import kotlinx.coroutines.delay
import kotlinx.coroutines.launch
import team.platforma.materialextension.moc_data.TaskStatus
import team.platforma.materialextension.moc_data.allTasksStatuses
import team.platforma.materialextension.moc_data.cabinetTasksStatuses
import team.platforma.multiplatform_material_extension.bottom_sheet.CommonBottomSheet
import team.platforma.multiplatform_material_extension.pie_chart.PieChart6
import team.platforma.multiplatform_material_extension.scrollbar.VerticalScrollIndicator
import team.platforma.multiplatform_material_extension.tab_row.AdaptiveTabRow
import team.platforma.multiplatform_material_extension.ui.dialog.utils.isVisible
import team.platforma.multiplatform_material_extension.ui.dialog.utils.rememberCommonDialogViewState

@OptIn(ExperimentalMaterial3Api::class)
@Composable
fun ListScreen() {

    Box(
        modifier = Modifier.fillMaxSize()
    ) {
        val lazyListState = rememberLazyListState()

        val list = remember { mutableStateListOf(1) }

        var bottomSheet by remember { mutableStateOf(false) }

        Column {
            Button(
                onClick = {
                    list.addAll(listOf(1))
                }
            ) {
                Text(
                    "add items"
                )
            }
            Button(
                onClick = {
                    list.removeLast()
                }
            ) {
                Text(
                    "remove"
                )
            }
            Button(
                onClick = {
                    bottomSheet = true
                }
            ) {
                Text(
                    "bottom sheet"
                )
            }
            var percent by remember { mutableStateOf(0f) }

            PieChart6(
                completedPercent = percent
            )

            Slider(
                modifier = Modifier.padding(24.dp),
                value = percent,
                onValueChange = {
                    percent = it
                }
            )

            VerticalScrollIndicator(
                state = lazyListState,
            ) {
                val scope = rememberCoroutineScope()
                var isRefreshing by remember { mutableStateOf(false) }
                PullToRefreshBox(
                    isRefreshing = isRefreshing,
                    onRefresh = {
                        scope.launch {
                            isRefreshing = true
                            delay(5000)
                            isRefreshing = false
                        }

                    }
                ) {

                    var taskStatusTabs by remember { mutableStateOf(cabinetTasksStatuses()) }
                    val taskPagerState = rememberPagerState(pageCount = { taskStatusTabs.size })

                    LazyColumn(
                        modifier = Modifier.fillMaxSize(),
                        state = lazyListState,
                        contentPadding = PaddingValues(horizontal = 16.dp),
                        verticalArrangement = Arrangement.spacedBy(8.dp)
                    ) {
                        item {
                            Column {
                                AdaptiveTabRow <TaskStatus> (
                                    pagerState = taskPagerState ,
                                    tabList = taskStatusTabs,
                                    tab = { taskStatus ->
                                        Text(
                                            text = taskStatus.name
                                        )
                                    }
                                )
                                Button(
                                    onClick = {
                                        taskStatusTabs = allTasksStatuses()
                                    }
                                ) {}
                            }

                        }
                        itemsIndexed(list) { index, item ->
                            Box(
                                modifier = Modifier.fillMaxWidth().height(700.dp)
                                    .border(1.dp, color = Color.Green)
                            ) {
                                Text(
                                    "item $index"
                                )
                            }
                        }
                    }
                }



                if (bottomSheet) {
                    val dialogState = rememberCommonDialogViewState()

                    CommonBottomSheet(
                        modifier = Modifier.then(
                            if (dialogState.isVisible()) Modifier.blur(5.dp) else Modifier
                        ),
                        fullScreen = true,
                        onDismiss = {
                            bottomSheet = false
                        },
                        dragHandle = { sheetHelper, color ->
                            Column(
                                modifier = Modifier.fillMaxWidth()
                            ) {
                                Box(
                                    modifier = Modifier
                                        .padding(top = 16.dp)
                                        .width(40.dp)
                                        .height(4.dp)
                                        .background(color, shape = RoundedCornerShape(2.dp))
                                )
                                Text(
                                    "Some Text"
                                )
                            }

                        }
                    ) { sheetHelper ->

//                        PersonalDataPhoneTestSample()

                        Column {
                            Text(
                                "some text"
                            )
                            Text(
                                "some text"
                            )
                            Text(
                                "some text"
                            )
                            Text(
                                "some text"
                            )
                            Text(
                                "some text"
                            )
                        }

                    }

                }

            }
        }
    }

}

